export const ADMIN_EQUIVALENT_ROLES = ['ADMIN', 'TESOUREIRO', 'SUPER_ADMIN'];
export const FINANCE_ROLES = ['TESOUREIRO', 'SUPER_ADMIN'];
export const PRIVILEGED_ROLES = ['TESOUREIRO', 'SUPER_ADMIN'];

export const isAdminEquivalent = (role) => ADMIN_EQUIVALENT_ROLES.includes(role);

export const isFinanceRole = (role) => FINANCE_ROLES.includes(role);

const ROLE_LABELS = {
  SUPER_ADMIN: 'Super Admin',
  TESOUREIRO: 'Tesoureiro',
  ADMIN: 'Administrador',
  RECRUITER: 'Recrutador',
};

export const getRoleLabel = (role) => ROLE_LABELS[role] || 'Membro';

// Só SUPER_ADMIN pode atribuir os papéis TESOUREIRO ou SUPER_ADMIN.
export const canAssignRole = (actingRole, targetRole) => {
  if (PRIVILEGED_ROLES.includes(targetRole)) {
    return actingRole === 'SUPER_ADMIN';
  }
  return isAdminEquivalent(actingRole);
};
